export default __webpack_public_path__ + "static/empresa-d64ebcf71c4338f677aa270200945509.png";